'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _express = require('express');

var _minimajs = require('minimajs');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PluginsRestHandler = function () {
    /**
     * Creates an instance of PluginsRestHandler.
     * 
     * @param {Plugin} plugin 
     * @memberof PluginsRestHandler
     */
    function PluginsRestHandler(plugin) {
        (0, _classCallCheck3.default)(this, PluginsRestHandler);

        this.plugin = plugin;

        this.handle = this.handle.bind(this);
    }

    /**
     * Handle a REST request: http://locahost:3000/systemPlugins/plugins
     * 
     * @param {Request} request 
     * @param {Response} response 
     * @memberof PluginsRestHandler
     */


    (0, _createClass3.default)(PluginsRestHandler, [{
        key: 'handle',
        value: function handle(request, response) {
            var pluginContext = this.plugin.context;
            var plugins = [];
            var index = 1;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(pluginContext.getPlugins()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var pair = _step.value;

                    var plugin = {
                        'index': index,
                        'id': pair[1].id,
                        'name': pair[1].name,
                        'version': pair[1].version.versionString,
                        'state': pair[1].state.state
                    };
                    plugins.push(plugin);
                    index++;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            response.json(plugins);
        }
    }]);
    return PluginsRestHandler;
}();

exports.default = PluginsRestHandler;
//# sourceMappingURL=PluginsRestHandler.js.map